//
//
//
//
//
//
//
//
//
//
//
//

export default {
  async asyncData({ $storyblok, $api, store, params }) {
    const page = await $storyblok
      .getPage(`locations/${params.location}`)
      .then(async (store) => {
        // This is causing issues with site generation
        // const sid = store.content.store_num
        // const sloc = await $api.getLocation(sid)
        const sloc = {
          services: {
            pickup: store.content.pickup,
            curbside: store.content.curbside,
            delivery: store.content.delivery,
            dispatch: store.content.dispatch,
          }
        }
        if (sloc) {
          const asArray = Object.entries(sloc.services)
          const usedServices = asArray.filter(([key, value]) => value === true)
          sloc.services = Object.fromEntries(usedServices)
          return { ...store, sloc: sloc }
        } else {
          return store
        }
      })
    const promos = await $storyblok.getPage('globals/promotions')
    // let menu = await .$api.getMenu(l.menu_id)

    page.content.light_header = true
    page.name = `Perkins at ${page.content.address} ${page.content.city}, ${page.content.state}`
    store.commit('setPage', page)
    const story = await $storyblok.getPage(`pages/location`)
    const slider = story.content.body[0]
    const callout = story.content.body[1]

    let promotions = {
      cards: [],
      component: 'promotions',
    }

    promos.content.body[0].cards.map((p) => {
      page.content.specials.map((s) => {
        if (s.description == p.heading) {
          promotions.cards.push(p)
        }
      })
    })

    return {
      page,
      promotions,
      slider,
      callout,
    }
  },
  head() {
    return this.$metadata(this.page, true)
  },
}
